import React, { useEffect } from "react";
import {
    useSelector,
    // useDispatch
} from "./redux";
import { useRouter } from "next/router";
// import { createErrorMessage } from "@state/actions/messages";

export default function useIsAuthenticated(): boolean {
    const authReducer = useSelector((state) => state.authReducer);
    const router = useRouter();
    // const dispatch = useDispatch();

    // ensure we are authenticated
    useEffect(() => {
        if (process.env.NODE_ENV === "development") {
            console.log("withRequireAuth");
            console.log(
                "authReducer.isAuthenticated",
                authReducer.isAuthenticated
            );
            console.log(router);
        }
        if (
            router.isReady &&
            !authReducer.isLoading &&
            !authReducer.isAuthenticated
        ) {
            // redirect
            router.push({
                pathname: "/accounts/login",
                query: { ...router.query, next: router.pathname },
            });
            // dispatch(
            //     createErrorMessage("Authentication credentials not found!")
            // );
        }
    }, [authReducer.isAuthenticated, authReducer.isLoading, router.isReady]);

    return (
        !!router.isReady &&
        !authReducer.isLoading &&
        !!authReducer.isAuthenticated
    );
}
